/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component(props, {
  $f7,
  $f7router,
  $f7route,
  $update,
  $on
}) {
  let email = '';
  let otp = '';
  let loading = false;
  let countdown = 0;
  let countdownTimer = null;
  const otpChanged = function (event) {
    otp = event.target.value.replace(/\D/g, '').slice(0, 6);
    event.target.value = otp;
  };
  const startCountdown = function (seconds) {
    if (countdownTimer) {
      clearInterval(countdownTimer);
    }
    countdown = seconds;
    $update();
    countdownTimer = setInterval(function () {
      countdown--;
      if (countdown <= 0) {
        countdown = 0;
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
      $update();
    }, 1000);
  };
  const verifyOtp = async function (event) {
    event.preventDefault();
    if (loading) {
      return;
    }
    if (!/^\d{6}$/.test(otp)) {
      $f7.dialog.alert('कृपया 6 अंकों का OTP दर्ज करें।', 'OTP');
      return;
    }
    loading = true;
    $update();
    try {
      const response = await fetch('/api/auth/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          email: email,
          otp: otp
        })
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'OTP सत्यापित नहीं हो सका।');
      }
      if (data.token) {
        localStorage.setItem('User_Access_Token', data.token);
      }
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
      $f7router.navigate('/home/', {
        clearPreviousHistory: true,
        reloadCurrent: true
      });
    } catch (error) {
      console.error('OTP ERROR:', error);
      $f7.dialog.alert(error.message || 'OTP सत्यापित नहीं हो सका।', 'OTP समस्या');
    } finally {
      loading = false;
      $update();
    }
  };
  const resendOtp = async function (event) {
    event.preventDefault();
    if (loading || countdown > 0) {
      return;
    }
    loading = true;
    $update();
    try {
      const response = await fetch('/api/auth/request-signup-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email
        })
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'OTP भेजा नहीं जा सका।');
      }
      startCountdown(60);
      $f7.dialog.alert('नया OTP आपके ईमेल पर भेज दिया गया है।', 'OTP भेज दिया गया');
    } catch (error) {
      console.error('RESEND OTP ERROR:', error);
      $f7.dialog.alert(error.message || 'OTP भेजा नहीं जा सका।', 'OTP समस्या');
    } finally {
      loading = false;
      $update();
    }
  };
  $on('page:init', function () {
    email = $f7route.query.email || '';
    email = decodeURIComponent(email);
    startCountdown(60);
  });
  $on('page:beforeOut', function () {
    if (countdownTimer) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page login-page">
        <div class="login-content">

            <div class="login-brand">
                <div class="login-logo">P</div>
                <div class="login-title">पथक</div>
                <div class="login-subtitle">
                    गांव की प्रगति, सबकी भागीदारी
                </div>
            </div>

            <div class="login-card">

                <div class="login-heading">
                    ईमेल सत्यापित करें
                </div>

                <div class="login-description">
                    आपके ईमेल पर भेजा गया 6 अंकों का OTP दर्ज करें
                </div>

                <form class="login-form" @submit=${verifyOtp}>

                    <div class="login-field otp-field">
                        <i class="material-icons">verified_user</i>

                        <input
                            type="text"
                            name="otp"
                            inputmode="numeric"
                            maxlength="6"
                            autocomplete="one-time-code"
                            placeholder="6 अंकों का OTP"
                            @input=${otpChanged}
                            required
                            autofocus
                        />
                    </div>

                    <button
                        type="submit"
                        class="button button-fill login-button"
                        disabled=${loading}
                    >
                        <span>
                            ${loading
                                ? 'सत्यापित हो रहा है...'
                                : 'सत्यापित करें'}
                        </span>
                    </button>

                    <div class="otp-actions">

                        <a
                            href="#"
                            @click=${resendOtp}
                        >
                            ${countdown > 0
                                ? 'OTP दोबारा भेजें (' + countdown + 's)'
                                : 'OTP दोबारा भेजें'}
                        </a>

                        <a href="/signup/">
                            ईमेल बदलें
                        </a>

                    </div>

                </form>

            </div>

        </div>
    </div>
`
    }
    ;
}
framework7Component.id = '4a78228d31';
framework7Component.style = `
.login-page {
    background: #f7f4f0;
}

.login-content {
    width: 100%;
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
}

.login-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 18px;
    text-align: center;
}

.login-logo {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 7px;
    border-radius: 50%;
    background: #d94b05;
    color: #fff;
    font-size: 25px;
    font-weight: 700;
}

.login-title {
    color: #28231f;
    font-size: 25px;
    line-height: 1.1;
    font-weight: 700;
}

.login-subtitle {
    margin-top: 5px;
    color: #817970;
    font-size: 11px;
}

.login-card {
    width: 100%;
    max-width: 360px;
    box-sizing: border-box;
    padding: 22px;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 30px rgba(40, 35, 31, .08);
}

.login-heading {
    color: #28231f;
    font-size: 19px;
    font-weight: 700;
    text-align: center;
}

.login-description {
    margin-top: 5px;
    margin-bottom: 18px;
    color: #817970;
    font-size: 11px;
    line-height: 1.5;
    text-align: center;
}

.login-form {
    width: 100%;
}

.login-field {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    gap: 9px;
    box-sizing: border-box;
    margin-bottom: 11px;
    padding: 0 12px;
    border: 1px solid #ded8d2;
    border-radius: 8px;
    background: #fff;
}

.login-field:focus-within {
    border-color: #d94b05;
}

.login-field .material-icons {
    flex-shrink: 0;
    color: #817970;
    font-size: 18px;
}

.login-field input {
    width: 100%;
    height: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: #28231f;
    font-family:
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        "Noto Sans Devanagari",
        sans-serif;
    font-size: 13px;
    line-height: normal;
    appearance: none;
}

.login-field input::placeholder {
    color: #9b938b;
    opacity: 1;
}

.otp-field input {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 5px;
    text-align: center;
}

.otp-field input::placeholder {
    letter-spacing: normal;
    font-size: 12px;
    font-weight: 400;
}

.login-button {
    width: 100%;
    height: 43px;
    min-height: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    padding: 0 15px;
    border: 0;
    border-radius: 8px;
    background: linear-gradient(90deg, #d94b05, #e65d08);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

.login-button:disabled {
    opacity: .65;
}

.otp-actions {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 17px;
    font-size: 11px;
}

.otp-actions a {
    color: #d94b05;
    font-weight: 600;
    text-decoration: none;
}
`;
export default framework7Component;